import React, { useState } from 'react';
import {
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Chip,
  Typography,
  Box,
  Menu,
  MenuItem,
  withStyles
} from '@material-ui/core';
import { SORTIE_TASK_STATES } from '../../constants';

const styles = (theme) => ({
  chipNotStarted: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
  chipInProgress: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
  },
  chipComplete: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.contrastText,
  },
  chipNotApplicable: {
    backgroundColor: theme.palette.grey[500],
    color: theme.palette.grey[50],
  },
});

const TaskItem = ({ task, onStatusChange, canEdit, classes }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const getStatusClass = (status) => {
    switch (status) {
      case SORTIE_TASK_STATES.COMPLETE:
        return classes.chipComplete;
      case SORTIE_TASK_STATES.IN_PROGRESS:
        return classes.chipInProgress;
      case SORTIE_TASK_STATES.NOT_APPLICABLE:
        return classes.chipNotApplicable;
      case SORTIE_TASK_STATES.NOT_STARTED:
        return classes.chipNotStarted;
      default:
        return '';
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (status) => {
    onStatusChange(status);
    handleClose();
  };

  return (
    <ListItem divider>
      <ListItemText
        primary={task.label}
        secondary={
          task.status === SORTIE_TASK_STATES.COMPLETE && task.completedBy && (
            <Typography variant="caption" color="textSecondary">
              Completed by: {task.completedBy}
            </Typography>
          )
        }
      />
      <ListItemSecondaryAction>
        <Box display="flex" alignItems="center">
          <Chip
            label={task.status.replace('_', ' ').toUpperCase()}
            className={getStatusClass(task.status)}
            size="small"
            onClick={canEdit ? handleClick : undefined}
            style={{ cursor: canEdit ? 'pointer' : 'default' }}
          />
          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {Object.values(SORTIE_TASK_STATES).map((status) => (
              <MenuItem 
                key={status} 
                onClick={() => handleSelect(status)}
                selected={task.status === status}
              >
                {status.replace('_', ' ').toUpperCase()}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default withStyles(styles)(TaskItem);
